import React from 'react';

interface NaturaBadgeProps {
  natura: string;
}

const colorMap: Record<string, string> = {
  costo: 'bg-red-100 text-red-800',
  ricavo: 'bg-green-100 text-green-800',
  profitto: 'bg-purple-100 text-purple-800',
};

const NaturaBadge: React.FC<NaturaBadgeProps> = ({ natura }) => {
  const cls = colorMap[natura] ?? 'bg-gray-100 text-gray-700';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${cls}`}>
      {natura}
    </span>
  );
};

export default NaturaBadge;
